import ModalConfirmar from '../ui/ModalConfirmar';
import Ayuda from '../ui/Ayuda';
import { nombreDelTipo } from './codigos';

// «QUITAR» UN CÓDIGO PIDE CONFIRMACIÓN · U-02 fase a (DISEÑO §6.2).
//
// Antes, «Quitar» llamaba al DELETE en el mismo clic: un dedo que se
// resbala en el teléfono dejaba al producto sin el código con que se
// escanea, y nadie veía qué había pasado (Doctrina 2, regla 7: toda acción
// riesgosa pide confirmación explicando la consecuencia en una frase). La
// consecuencia es una ayuda del catálogo (`codigos.quitar`), pegada al
// botón que la ejecuta.
//
// `onQuitar` hace la llamada y lanza si falla: el propio modal enseña el
// error y se queda abierto, igual que todos los ModalConfirmar.
export default function ConfirmarQuitarCodigo({ codigo, onQuitar, onCerrar }) {
  return (
    <ModalConfirmar
      titulo="¿Quitar este código?"
      descripcion={
        <>
          <span className="block font-mono break-all text-gray-900">{codigo.codigo}</span>
          <span className="block">
            {nombreDelTipo(codigo.tipo)}
            {codigo.principal ? ' · Es el principal: el siguiente de la lista pasa a serlo.' : ''}
          </span>
        </>
      }
      extra={<Ayuda id="codigos.quitar" />}
      etiquetaConfirmar="Sí, quitarlo"
      peligro
      onConfirmar={onQuitar}
      onCerrar={onCerrar}
    />
  );
}
